let prefix_ms = location.origin;

if (process.env.NODE_ENV === "development") {//开发环境
  prefix_ms = '/cp/v2';
} else { //生产环境
  prefix_ms = location.origin + '/api/v2';
}

export default prefix_ms



//////////////////
// WEBPACK FOOTER
// ./app/api/prefix.js
// module id = null
// module chunks = 